import React from "react"
import { Link } from "gatsby"
import Sticky from "react-sticky-el"
import { Nav } from "react-bootstrap"
import SEO from "../components/seo"
import { LazyLoadImage } from "react-lazy-load-image-component"
import "react-lazy-load-image-component/src/effects/blur.css"

import uiomimg from "../images/UIOM.png"

class UIOM extends React.Component {
	render() {
		const scrollTop = () => {
			window.scrollTo({ top: 0, behavior: "smooth" })
		}
		const siteTitle = "UIOM"
		const siteDescription = this.props.data.site.siteMetadata.description
		return (
			<div style={{ overflow: `hidden` }} id="back-to-top">
				<SEO title={siteTitle} description={siteDescription} />
				<Sticky
					id="sticky-wrapper"
					className="sticky-wrapper"
					stickyClassName="is-sticky"
					stickyStyle={{ transform: "unset", zIndex: "999" }}
				>
					<Nav
						className="navbar navbar-light navbar-expand-md navigation-clean"
						style={{ zIndex: "1" }}
					>
						<div className="container-fluid">
							<div className="row text-center w-100">
								<div className="col-md-12">
									<ul>
										<li className="d-inline">
											<Link className="navbar-brand" to="/">
												&nbsp; &nbsp; HOME
											</Link>
										</li>
										<li className="d-inline">
											<Link className="navbar-brand" to="/uiom">
												&nbsp; &nbsp; UIOM
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</Nav>
				</Sticky>
				<div className="container">
					<div className="row">
						<div className="col">
							<LazyLoadImage
								src={uiomimg}
								alt="UIOM"
								className="mt-5 img-fluid"
								effect="blur"
							/>
							<p className="mt-4">Use It On Monday - February 23, 2020</p>
							<p>
								Spend a morning learning with Southern Colorado’s premier
								veterinary specialists at our 15th annual Use It On Monday CE on
								Sunday, February 23, 2020. This educational event is worth 4
								hours of CE credit and features an exciting range of topics that
								appeal to both doctors and technicians in a concise format.
							</p>
							<a className="register" href="http://useitonmondayce.com/">
								Register Today
							</a>
						</div>
					</div>
				</div>
				<div className="footer-uiom mt-5">
					<div className="container">
						<div className="footer-grid">
							<div className="grid-33" />
							<div className="grid-33">
								<p className="p-0" style={{ fontSize: `12px` }}>
									COPYRIGHT © 2020{" "}
									<strong>
										<a
											href="https://canineortho-vetspecialty-bxj.netlify.app/"
											target="_blank"
											rel="noopener noferrer"
										>
											VETERINARY SPECIALITY CENTER
										</a>
									</strong>
								</p>
							</div>
							<div className="grid-33 text-right">
								<a type="button" onClick={scrollTop}>
									<i
										className="fa fa-2x fa-arrow-circle-o-up"
										style={{ color: `#484848` }}
									/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default UIOM

export const UIOMPageQuery = graphql`
	query UIOMPageQuery {
		site {
			siteMetadata {
				title
				author
				description
			}
		}
	}
`
